module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('right-panel', {
    ref: "right-panel",
    attrs: {
      "datas": _vm.connects
    },
    on: {
      "onClose": _vm.onCloseForm
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Set Cluster")])], 1), _vm._v(" "), _c('div', {
    staticClass: "set-cluster-content",
    slot: "content"
  }, [_c('el-form', {
    ref: "setClusterForm",
    attrs: {
      "model": _vm.clusterSetForm,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.name,
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.clusterSetForm.name),
      callback: function($$v) {
        _vm.clusterSetForm.name = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "clusterSetForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.ip,
      "prop": "agent_host_alias"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.clusterSetForm.agent_host_alias),
      callback: function($$v) {
        _vm.clusterSetForm.agent_host_alias = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "clusterSetForm.agent_host_alias"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.code
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1"
    },
    model: {
      value: (_vm.clusterSetForm.codeSet),
      callback: function($$v) {
        _vm.clusterSetForm.codeSet = $$v
      },
      expression: "clusterSetForm.codeSet"
    }
  }, [_c('translate', [_vm._v("Default")])], 1), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    },
    model: {
      value: (_vm.clusterSetForm.codeSet),
      callback: function($$v) {
        _vm.clusterSetForm.codeSet = $$v
      },
      expression: "clusterSetForm.codeSet"
    }
  }, [_c('translate', [_vm._v("Customize")])], 1)], 1), _vm._v(" "), (_vm.clusterSetForm.codeSet === '2') ? _c('el-form-item', {
    attrs: {
      "label": " ",
      "prop": "time"
    }
  }, [_c('el-input', {
    staticClass: "set-input",
    model: {
      value: (_vm.clusterSetForm.time),
      callback: function($$v) {
        _vm.clusterSetForm.time = _vm._n($$v)
      },
      expression: "clusterSetForm.time"
    }
  }), _vm._v(" "), _c('el-select', {
    staticClass: "set-select",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.clusterSetForm.timeType),
      callback: function($$v) {
        _vm.clusterSetForm.timeType = $$v
      },
      expression: "clusterSetForm.timeType"
    }
  }, _vm._l((_vm.timeArr), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "set-note"
  }, [_c('translate', [_vm._v("Log in resource need to generate a code, every code has a effective period,This term set the maximum effective period that user can set.")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "0"
    },
    attrs: {
      "label": _vm.attrText.ConnectMap,
      "prop": ""
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.clusterSetForm.is_open_map),
      callback: function($$v) {
        _vm.clusterSetForm.is_open_map = $$v
      },
      expression: "clusterSetForm.is_open_map"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "set-note"
  }, [_c('translate', [_vm._v("Note: After enabling the service connection mapping function, the IP and port displayed during actual connection will be subject to the current mapping rules.")])], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.clusterSetForm.port_map_info
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ip_name",
      "label": _vm.attrText.ipName
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin_port",
      "label": _vm.attrText.originPort
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "map_port",
      "label": _vm.attrText.mapPort
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "type": "number"
          },
          on: {
            "change": function($event) {
              _vm.changeMapPort(scope.row)
            }
          },
          model: {
            value: (scope.row.map_port),
            callback: function($$v) {
              scope.row.map_port = _vm._n($$v)
            },
            expression: "scope.row.map_port"
          }
        })]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onSubmit()
      }
    }
  }, [_c('translate', [_vm._v("Submit")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.onCloseForm()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b2a0a52"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/model/cluster-set.vue
// module id = 585
// module chunks = 4 5 6